import React from "react";
import internet_anim_02 from "../assets/animation/internet-anim-02.json";
import LottieAnimator from "./ui-elements/LottieAnimator";
import { FiCheckCircle, FiShield, FiWifi, FiTv, FiHeadphones } from "react-icons/fi";
import { useLanguage } from "../context/LanguageContext";

export default function AboutSection() {
  const { t } = useLanguage();

  const features = [
    {
      icon: FiWifi,
      title: t("about.feat1Title"),
      desc: t("about.feat1Desc"),
    },
    {
      icon: FiTv,
      title: t("about.feat2Title"),
      desc: t("about.feat2Desc"),
    },
    {
      icon: FiShield,
      title: t("about.feat3Title"),
      desc: t("about.feat3Desc"),
    },
    {
      icon: FiHeadphones,
      title: t("about.feat4Title"),
      desc: t("about.feat4Desc"),
    },
  ];

  return (
    <section id="about" className="w-full py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Lottie Animation */}
          <div className="lg:col-span-5 w-full max-w-[380px] mx-auto">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-red-100 to-amber-100 rounded-3xl filter blur-xl opacity-70 -z-10" />
              <div className="bg-slate-50/70 p-6 rounded-3xl border border-slate-100 shadow-sm">
                <LottieAnimator lottie={internet_anim_02} />
              </div>
            </div>
          </div>

          {/* Text and Story */}
          <div className="lg:col-span-7 space-y-6">
            <div className="inline-flex items-center space-x-2 px-3.5 py-1.5 rounded-full bg-red-50 border border-red-100 text-brandRed text-xs font-bold uppercase tracking-wider">
              <FiCheckCircle size={13} />
              <span>{t("about.badge")}</span>
            </div>

            <h2 className="text-3xl md:text-5xl font-black text-slate-900 tracking-tight uppercase">
              {t("about.title")}
            </h2>

            <div className="space-y-4 text-slate-600 text-base leading-relaxed">
              <p>{t("about.storyP1")}</p>
              <p>{t("about.storyP2")}</p>
            </div>

            {/* Feature Cards Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
              {features.map((feat, idx) => (
                <div
                  key={idx}
                  className="p-4 rounded-2xl border border-slate-100 bg-slate-50/60 flex items-start space-x-3.5"
                >
                  <div className="w-10 h-10 rounded-xl bg-white text-brandRed shadow-sm flex items-center justify-center flex-shrink-0">
                    <feat.icon size={20} />
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-slate-900 uppercase">
                      {feat.title}
                    </h4>
                    <p className="text-xs text-slate-500 mt-1 leading-normal">
                      {feat.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
